import { ButtonHTMLAttributes } from "react"

const BUTTON_TYPES = {
    "primary": "bg-aura-green disabled:bg-mid-gray font-semibold rounded-lg text-white enabled:hover:scale-[0.95] duration-300 enabled:active:scale-90 ",
    "secondary": "bg-white font-thin border border-black text-black rounded-md disabled:border-mid-gray disabled:text-mid-gray font-semibold enabled:hover:scale-[0.95] duration-300 enabled:active:scale-90",
    "tertiary": "text-aura-blue underline decoration-solid decoration-aura-blue disabled:text-mid-gray disabled:decoration-mid-gray"
}

type ButtonVariants = keyof typeof BUTTON_TYPES

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    variant: ButtonVariants
    className?: string
}

export const Button = ({ children, variant, onClick, className, ...props }: ButtonProps) => {
    return <button onClick={onClick} className={`${BUTTON_TYPES[variant]} px-4 py-2 ${className}`} {...props}>{children}</button>
}